import {SOPutProject} from '../../core/project/so-put-project';
import {ProjectCore} from './project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {FormField, SelectionOption} from 'lionheartland';
import {putProjectFormFieldOptions} from './put-project-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePut} from 'lionheartland';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPutProject extends BasePut implements AdapterProtocol {
  formFieldOptions = Object.values(putProjectFormFieldOptions);

  RequestClass = SOPutProject

  constructor(
    public entityCore: ProjectCore
  ) {
    super();
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.selectedEntity.uid,
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('description'),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}